const ErrorFormHelper = (errors: any, field?: string) => {
    let isInvalid = false;

    if (!errors) return;

    if (field === undefined) {
        isInvalid = errors.length > 0 ? true : false;
    } else {
        const fieldSplit = field.split(",");
        isInvalid = errors.some((error: any) => fieldSplit.includes(error.field));
    }

    if (isInvalid) {
        return " is-invalid";
    }

    return '';
}

export default ErrorFormHelper;
